import type { PageContext } from 'vike/types'

export function title(pageContext: PageContext) {
    const { data } = pageContext
    return data?.title
}